import { render, staticRenderFns } from "./yangzhou.vue?vue&type=template&id=947a62a8&"
import script from "./yangzhou.vue?vue&type=script&lang=js&"
export * from "./yangzhou.vue?vue&type=script&lang=js&"
import style0 from "./yangzhou.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports